<div class="container-fluid">
    <div class="row">
        <app-speed-dial-fab (clicked)="dispatch($event)" [options]="FabOptions"></app-speed-dial-fab>
        <div class="col-12 col-xl-6 my-1">
            <div class="border rounded-1 background-light p-3">
                <!-- <h5 class="card-header">Mesure station</h5> -->
                <div class="row">
                    <h2 class="col text-center fw-bold"> Mesure station</h2>
                </div>
                <div class="row mt-1">
                    <h6 class="d-flex align-items-center m-0 col-auto">Longueurs de la station</h6>

                    <button appPreventDoubleClick [throttleTime]="200" mat-icon-button color="primary" (throttledClick)="openMesureBox()">
                        <mat-icon>add</mat-icon>
                    </button>

                </div>
                <div class="row">
                    <div *ngFor="let largueur of model.MesureStation.LongueurStations; let i = index" class="col-6 col-md-3">
                        <div class="border rounded-4 p-3 m-1 row">
                            <mat-form-field class="w-100">
                                <mat-label>{{getLongueurName(i)}}</mat-label>
                                <input matInput [placeholder]="getLongueurName(i)" type="number" [(ngModel)]="largueur.Longueur">
                            </mat-form-field>
                            <div class="row d-flex justify-content-center p-0">

                                <button appPreventDoubleClick [throttleTime]="200" mat-icon-button color="primary" (throttledClick)="openMesureBox(largueur)">
                                    <mat-icon>edit</mat-icon>
                                </button>
                                <button appPreventDoubleClick [throttleTime]="200" mat-icon-button color="primary" (throttledClick)="removeMeasure(largueur)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="row">
                    <mat-form-field class="col">
                        <input matInput placeholder="L2" type="number" [(ngModel)]="model.MesureStation.Longueurs[1].Longueur">
                    </mat-form-field>
                </div>
                <div class="row">
                    <mat-form-field class="col">
                        <input matInput placeholder="L3" type="number" [(ngModel)]="model.MesureStation.Longueurs[2].Longueur">
                    </mat-form-field>
                </div>
                <div class="row">
                    <mat-form-field class="col">
                        <input matInput placeholder="L4" type="number" [(ngModel)]="model.MesureStation.Longueurs[3].Longueur">
                    </mat-form-field>
                </div>
                <div class="row">
                    <mat-form-field class="col">
                        <input matInput placeholder="L5" type="number" [(ngModel)]="model.MesureStation.Longueurs[4].Longueur">
                    </mat-form-field>
                </div> -->
                <div class="row mt-3">
                    <h6>Longueurs calculées</h6>
                </div>
                <div class="row">
                    <div class="col">
                        Lm moy {{computeLmMoy() | number: '1.1-1'}}
                    </div>
                    <div class="col">
                        Lt théo {{computeLtTheo() | number: '1.1-1'}}
                    </div>
                    <div class="col">
                        <mat-form-field class="col">
                            <mat-label>Lt réelle</mat-label>
                            <input matInput placeholder="Lt réelle" type="number" [(ngModel)]="model.MesureStation.LtReelle">
                        </mat-form-field>
                    </div>
                </div>

            </div>
        </div>
        <div class="col-12 col-xl-6 my-1">
            <div class="border rounded-1 background-light p-3">
                <!-- <h5 class="card-header">Localisation</h5> -->
                <div class="row">
                    <h2 class="col text-center fw-bold"> Localisation</h2>
                </div>
                <div class="row">

                    <div class="row text-center">
                        <div class="col fw-bold">
                            Amont
                        </div>
                    </div>
                    <div class="col">
                        <mat-form-field class="w-100">
                            <mat-label>X</mat-label>
                            <input matInput placeholder="X" type="number" [(ngModel)]="model.LocalisationStation.Amont.L93X" [formControl]="IsAmontX2FarControl" (keyup)="onAmontXKeyUpEvent($event)">
                            <mat-error *ngIf="IsAmontX2FarControl.hasError('pattern')">
                                Format erroné. 6 chiffres uniquement !
                            </mat-error>
                            <mat-error *ngIf="!IsAmontX2FarControl.valid && !IsAmontX2FarControl.hasError('pattern')">
                                Ecart > 500
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col">
                        <mat-form-field class="w-100">
                            <mat-label>Y</mat-label>
                            <input matInput placeholder="Y" type="number" [(ngModel)]="model.LocalisationStation.Amont.L93Y" [formControl]="IsAmontY2FarControl" (keyup)="onAmontYKeyUpEvent($event)">
                            <mat-error *ngIf="IsAmontY2FarControl.hasError('pattern')">
                                Format erroné. 7 chiffres uniquement !
                            </mat-error>
                            <mat-error *ngIf="!IsAmontY2FarControl.valid && !IsAmontY2FarControl.hasError('pattern')">
                                Ecart > 500
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">

                    <div class="row text-center">
                        <div class="col fw-bold">
                            Aval
                        </div>
                    </div>
                    <div class="col">
                        <mat-form-field class="w-100">
                            <mat-label>X</mat-label>
                            <input matInput placeholder="X" type="number" [(ngModel)]="model.LocalisationStation.Aval.L93X" [formControl]="IsAvalX2FarControl" (keyup)="onAvalXKeyUpEvent($event)">
                            <mat-error *ngIf="IsAvalX2FarControl.hasError('pattern')">
                                Format erroné. 6 chiffres uniquement !
                            </mat-error>
                            <mat-error *ngIf="!IsAvalX2FarControl.valid && !IsAvalX2FarControl.hasError('pattern')">
                                Ecart > 500
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col">
                        <mat-form-field class="w-100">
                            <mat-label>Y</mat-label>
                            <input matInput placeholder="Y" type="number" [(ngModel)]="model.LocalisationStation.Aval.L93Y" [formControl]="IsAvalY2FarControl" (keyup)="onAvalYKeyUpEvent($event)">
                            <mat-error *ngIf="IsAvalY2FarControl.hasError('pattern')">
                                Format erroné. 7 chiffres uniquement !
                            </mat-error>
                            <mat-error *ngIf="!IsAvalY2FarControl.valid && !IsAvalY2FarControl.hasError('pattern')">
                                Ecart > 500
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="row text-center">
                        <div class="col fw-bold">
                            Commentaire
                        </div>
                    </div>

                    <div class="col">
                        <mat-form-field class="w-100">
                            <mat-label>Limite Amont</mat-label>
                            <input matInput placeholder="Limite Amont" [(ngModel)]="model.LocalisationStation.LimiteAmont" [formControl]="ValidAmontMaxLength">
                            <mat-hint align="end">{{model.LocalisationStation.LimiteAmont?.length || 0}}/{{COMMENT_MAX_SIZE}}</mat-hint>
                            <mat-error *ngIf="ValidAmontMaxLength.hasError('maxlength')">
                                Texte trop long
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col">
                        <mat-form-field class="w-100">
                            <mat-label>Limite Aval</mat-label>
                            <input matInput placeholder="Limite Aval" [(ngModel)]="model.LocalisationStation.LimiteAval" [formControl]="ValidAvalMaxLength">
                            <mat-hint align="end">{{model.LocalisationStation.LimiteAval?.length || 0}}/{{COMMENT_MAX_SIZE}}</mat-hint>
                            <mat-error *ngIf="ValidAvalMaxLength.hasError('maxlength')">
                                Texte trop long
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>